// extracted by mini-css-extract-plugin
module.exports = {"Text":"ProfileEditor_Text__2zZCb"};